module.exports = __webpack_public_path__ + "static/media/five.0b96be04.svg";